<template>
    <confirmation-dialog :model-value="modelValue" :title="t('RESET_PROGRESS_DIALOG_TITLE')" :confirm-text="t('RESET_PROGRESS_DIALOG_CONFIRM')" :cancel-text="t('RESET_PROGRESS_DIALOG_CANCEL')" checkbox :confirmation-message="t('RESET_PROGRESS_DIALOG_ACKNOWLEDGEMENT')" form-instruction :disabled="isLoading" @confirm="onConfirm" @cancel="onCancel" data-testing="reset-progress-dialog">
        <p data-testing="reset-progress-dialog-message">{{ t('RESET_PROGRESS_DIALOG_MESSAGE') }}</p>
    </confirmation-dialog>
    <cr-confirmation-dialog :model-value="showLoadingDialog" :cancel="false" :confirm="false" hide-title persistent data-testing="reset-progress-loading-dialog">
        <div class="reset-progress-loading-wrapper">
            <cr-loading :message="t('RESET_PROGRESS_LOADING_DIALOG_MESSAGE')" data-testing="reset-progress-loading"/>
        </div>
    </cr-confirmation-dialog>
    <confirmation-dialog v-model="showCompleteDialog" :title="t('RESET_PROGRESS_COMPLETE_DIALOG_TITLE')" :confirm-text="t('RESET_PROGRESS_COMPLETE_DIALOG_CONFIRM')" :cancel="false" @confirm="onCompleteConfirm" data-testing="reset-progress-complete-dialog">
        <p data-testing="reset-progress-complete-dialog-message">{{ t('RESET_PROGRESS_COMPLETE_DIALOG_MESSAGE') }}</p>
    </confirmation-dialog>
</template>

<style scoped>
.reset-progress-loading-wrapper
{
    display: flex;
    justify-content: center;
}
</style>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useTeamStore } from '../../stores/teamStore';
import { useCompetitionStore } from '../../stores/competitionStore';
import ConfirmationDialog from './ConfirmationDialog.vue';
import Route from '../../routers/route';
import { useApiClientStore } from '../../stores/apiClientStore';
import { storeToRefs } from 'pinia';

const { t } = useI18n();
const router = useRouter();
let { isLoading } = storeToRefs(useApiClientStore());

const showCompleteDialog = ref(false);
const showLoadingDialog = ref(false);

defineProps<
{
    modelValue?: boolean;
}>();

const emit = defineEmits<{
    (e: 'confirm'): void;
    (e: 'cancel'): void;
    (e: 'update:modelValue', value: boolean): void;
}>();

async function onConfirm(): Promise<void>
{
    emit('update:modelValue', false);
    showLoadingDialog.value = true;

    await useTeamStore().leave();
    await useCompetitionStore().joinCompetition();

    emit('confirm');
    showLoadingDialog.value = false;
    showCompleteDialog.value = true;
}

function onCancel(): void
{
    emit('cancel');
}

function onCompleteConfirm(): void
{
    showCompleteDialog.value = false;
    router.push({ name: Route.LevelSelect.name });
}
</script>